import { render, staticRenderFns } from "./CollectionMobileMenu.vue?vue&type=template&id=0d0a4257&scoped=true&lang=pug&"
import script from "./CollectionMobileMenu.vue?vue&type=script&lang=js&"
export * from "./CollectionMobileMenu.vue?vue&type=script&lang=js&"
import style0 from "./CollectionMobileMenu.vue?vue&type=style&index=0&id=0d0a4257&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0a4257",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d0a4257')) {
      api.createRecord('0d0a4257', component.options)
    } else {
      api.reload('0d0a4257', component.options)
    }
    module.hot.accept("./CollectionMobileMenu.vue?vue&type=template&id=0d0a4257&scoped=true&lang=pug&", function () {
      api.rerender('0d0a4257', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/CollectionMobileMenu.vue"
export default component.exports